import React, { ReactElement, useEffect } from "react";
import type { HTMLProps, ReactNode } from "react";
import { useLocation } from "react-router-dom";

import { Box } from "@mui/material";
import { useTheme } from "@mui/material/styles";

import { capturePageView } from "../analytics/events";
import ErrorBoundary from "./ErrorBoundary";

interface PageProps extends HTMLProps<HTMLDivElement> {
  children?: ReactNode;
  title?: string;
}

const Page = ({ children, title }: PageProps): ReactElement => {
  const location = useLocation();
  const theme = useTheme();

  useEffect(() => {
    if (typeof title === "string") {
      document.title = title;
    }
  }, [title]);

  useEffect(() => {
    capturePageView(location.pathname, location.search, location.hash);
  }, [location.hash, location.pathname, location.search]);

  return (
    <Box
      sx={{
        padding: {
          xs: 1,
          sm: 2,
          md: 3,
          lg: 4,
        },
        width: "100vw",
        maxWidth: "100%",
        minHeight: "calc(100vh - 150px)",
        marginTop: theme.mixins.toolbar.height,
        alignItems: "center",
      }}
    >
      <ErrorBoundary>{children}</ErrorBoundary>
    </Box>
  );
};

export default Page;
